// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VDDdG","buttons":"styles_buttons__3VgA6"};